import React from "react";
import { api } from "@/lib/api";
import { euro } from "@/lib/format";
import { RicercaAsync } from "./RicercaAsync";

const filtra = (lista, q) => {
  const tok = q.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return lista
    .filter((s) => s.attivo !== false && tok.every((t) => `${s.codice} ${s.descrizione} ${s.categoria || ""}`.toLowerCase().includes(t)))
    .sort((a, b) => (a.descrizione || "").localeCompare(b.descrizione || ""));
};

// Elenco completo dal catalogo, filtrato lato client: non dipende dalla versione dell'endpoint /servizi/cerca
const cerca = async (q) => filtra((await api.get("/servizi")).data || [], q);
const risolvi = async (id) => ((await api.get("/servizi")).data || []).find((s) => s.id === id) || null;
const label = (s) => `${s.codice} · ${s.descrizione}${s.unita ? ` (${s.unita}` : ""}${s.prezzo_riferimento ? ` · ${euro(s.prezzo_riferimento)}` : ""}${s.unita ? ")" : ""}`;

// Ricerca nel catalogo Servizi (Anagrafica → Servizi). onChange(servizio|null)
export function RicercaServizio({ value, onChange, testid = "servizio-search", className }) {
  return <RicercaAsync value={value} onChange={onChange} cerca={cerca} risolvi={risolvi} label={label} placeholder="Scegli o cerca un servizio del catalogo…" testid={testid} className={className} minChars={0} />;
}
